import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "show_active",
  "use": "show_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"show_active\"><path d=\"M10 4c4.09 0 7.585 2.545 9 6.136-1.415 3.592-4.91 6.137-9 6.137s-7.585-2.545-9-6.137C2.415 6.545 5.91 4 10 4Zm0 2.682a3.451 3.451 0 0 0-3.455 3.454A3.451 3.451 0 0 0 10 13.591a3.451 3.451 0 0 0 3.455-3.455A3.451 3.451 0 0 0 10 6.682Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol